import React, { useState, cloneElement } from "react";
import headerImg from "../../assets/logoWhite.png";
import Container from "@material-ui/core/Container";
import { Link } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import RoomServiceIcon from "@material-ui/icons/RoomService";
import HomeIcon from "@material-ui/icons/Home";
import SettingsIcon from "@material-ui/icons/Settings";
import RestaurantMenuIcon from "@material-ui/icons/RestaurantMenu";
import LoyaltyIcon from "@material-ui/icons/Loyalty";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import StoreIcon from "@material-ui/icons/Store";
import PersonAddIcon from "@material-ui/icons/PersonAdd";

function CustomLink({ to, index, onClick, children, ...props }) {
	return (
		<Link style={{ textDecoration: "inherit" }} onClick={() => onClick(null, index)} to={to}>
			{cloneElement(children, { ...props })}
		</Link>
	);
}

function CustomAnkor({ style, href, children, ...props }) {
	return (
		<a style={style} href={href}>
			{cloneElement(children, { ...props })}
		</a>
	);
}
export default function Header({ isUserManager, isDev }) {
	const [value, setValue] = useState(0);
	const handleChange = (e, value) => {
		setValue(value);
	};
	const linkCSS = { color: "inherit", textDecoration: "inherit" };

	const renderIfDev = (
		<ScrollableTabsButtonForce handleChange={handleChange} value={value}>
			<CustomLink to="/" index={0} onClick={handleChange}>
				<Tab label="Home" icon={<HomeIcon />} id={0} />
			</CustomLink>
			<CustomLink to="/settings" index={1} onClick={handleChange}>
				<Tab label="Configuracion" icon={<SettingsIcon />} id={1} />
			</CustomLink>
			<CustomLink to="/menu" index={2} onClick={handleChange}>
				<Tab label="Menu" icon={<RestaurantMenuIcon />} id={2} />
			</CustomLink>
			<CustomLink to="/lealtad" index={3} onClick={handleChange}>
				<Tab label="Lealtad" icon={<LoyaltyIcon />} id={3} />
			</CustomLink>
			<CustomAnkor style={linkCSS} href={"https://milagritobar.com/consola"}>
				<Tab label="Consola" icon={<RoomServiceIcon />} id={4} />
			</CustomAnkor>
			<CustomAnkor style={linkCSS} href={"https://milagritobar.com/admin"}>
				<Tab label="Admin" icon={<SupervisorAccountIcon />} id={5} />
			</CustomAnkor>
			<CustomLink to="/store" index={6} onClick={handleChange}>
				<Tab label="Restaurantes" icon={<StoreIcon />} id={6} />
			</CustomLink>
			<CustomLink to="/userStore" index={7} onClick={handleChange}>
				<Tab label="Managers" icon={<PersonAddIcon />} id={7} />
			</CustomLink>
		</ScrollableTabsButtonForce>
	);

	const normalRender = (
		<ScrollableTabsButtonForce handleChange={handleChange} value={value}>
			<CustomLink to="/" index={0} onClick={handleChange}>
				<Tab label="Home" icon={<HomeIcon />} id={0} />
			</CustomLink>
			<CustomLink to="/settings" index={1} onClick={handleChange}>
				<Tab label="Configuracion" icon={<SettingsIcon />} id={1} />
			</CustomLink>
			<CustomLink to="/menu" index={2} onClick={handleChange}>
				<Tab label="Menu" icon={<RestaurantMenuIcon />} id={2} />
			</CustomLink>
			<CustomLink to="/lealtad" index={3} onClick={handleChange}>
				<Tab label="Lealtad" icon={<LoyaltyIcon />} id={3} />
			</CustomLink>
			<CustomAnkor style={linkCSS} href={"https://milagritobar.com/consola"}>
				<Tab label="Consola" icon={<RoomServiceIcon />} id={4} />
			</CustomAnkor>
			{isUserManager && (
				<CustomAnkor style={linkCSS} href={"https://milagritobar.com/admin"}>
					<Tab label="Admin" icon={<SupervisorAccountIcon />} id={5} />
				</CustomAnkor>
			)}
		</ScrollableTabsButtonForce>
	);

	return (
		<Container style={{ textAlign: "center", padding: 0 }}>
			<Link to="/">
				<img src={headerImg} alt="Logo el milagrito" style={{ maxHeight: "4em" }} />
			</Link>
			<nav>{isDev ? renderIfDev : normalRender}</nav>
		</Container>
	);
}

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`scrollable-force-tabpanel-${index}`}
			aria-labelledby={`scrollable-force-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box p={3}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		width: "100%",
		backgroundColor: theme.palette.background.paper,
	},
}));

function ScrollableTabsButtonForce({ children, value, handleChange }) {
	const classes = useStyles();
	return (
		<div className={classes.root}>
			<AppBar position="static" color="default" style={{ width: "100%" }}>
				<Tabs
					value={value}
					onChange={handleChange}
					variant="scrollable"
					scrollButtons="on"
					indicatorColor="primary"
					textColor="primary"
					aria-label="scrollable nav bar"
				>
					{children}
				</Tabs>
			</AppBar>
		</div>
	);
}
